import React from "react";
import { Box, Grid } from "@mui/material";

import { Tag } from "antd";
import { replaceContentEditableText } from "../../utils";
import {ReactComponent as VizIcon} from '../../Icons/vizIcon.svg';
import { useSelector } from "react-redux";
import VizIcons from '../../Icons/vizIcon.svg';

export default function NewGenAiAnswerComponent(props) {
    const containerStyle={
        height:'400px',
        border: '1px solid #E0E2E6',
        borderRadius: '12px',
        background:'#FFFFFF',
        boxShadow: '0px 4px 16px 0px #1018280F',
        marginTop:'8px'
    }
    const containerStyle1={
      height:'100px',
      border: '1px solid #E0E2E6',
      borderRadius: '12px',
      background:'#FFFFFF',
      boxShadow: '0px 4px 16px 0px #1018280F',
      marginTop:'8px'
  }
    // "No GenAi Summary available"
    const headingStyle={
       fontSize:'14px',
       lineHeight:'22px',
       fontWeight:'300',
       color:'#5C6676',
       paddingLeft:"6px",
       paddingTop:"6px"

    }
    const conatinerStyles={
        padding:'20px'
    }
    const textStyle={
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: '300',
        lineHeight: '24px',
        textAlign: 'left',
        color: '#5C667B'
    }
    const GentextStyle={
      fontFamily: 'Inter',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '24px',
      textAlign: 'left',
      color: '#5C667B'
  }
    const replaceHere=(str)=>{
      let newstr = str.replaceAll('\n','<br/>');
      return newstr;
    }
    const styles=props.data=="No GenAi Summary available" ? containerStyle1:containerStyle
	const searchSuggestionReducer = useSelector((state) => state.searchSuggestionsCM)
	return (
		<>
		
            <div style={styles}>
            
                 <div style={headingStyle}>
                  {/* <VizIcon/> */}
                  <img src={VizIcons} alt="VizIcon" width={20} height={20} />
                  &nbsp;<span style={GentextStyle}>GenAI Summary</span></div>
                <div style={{height:'320px', overflow:'auto'}}>
                <div style={conatinerStyles}>
              <div id="genaisummary" style={textStyle} dangerouslySetInnerHTML={{
                              __html: replaceHere(props.data),
                            }}></div>
                </div>
                </div>
                {/* <GenAiButtonSection/> */}
                     {/* <div style={{ display: "flex", alignItems: "center" }}>
                                           
                                           
                                            <Button2 onClickFunc={()=>console.log("clicked")}>
                                              <Rating id={data.docId===undefined?data.answerUuid:data.docId} />
                                            </Button2>
  </div> */}
                </div>
            
		</>
	)
}